import Component from '../../classes/Component';
import Swiper, {Navigation, Pagination} from 'swiper';
import variables from '../../variables';
import {isElement} from '../../helpers/_utilities';
import {$dom} from '../../helpers/dom';
import {$style} from '../../helpers/style';

const {get} = $dom;
const {offset} = $style;

export default function usageSection(
  rootId = 'home-usage',
  paginationSelector = '.js-home-usage-pagination',
  maxCountWithoutDynamicBullets = variables.maxCountWithoutDynamicBullets
) {

  const contentSection = get('.js-home-usage-content', `#${rootId}`);

  return new Component({
    name: 'homeUsage',
    requiredSelector: `#${rootId}`,
    rootElementId: rootId,
    onCreate() {
      this.carousel = null;
    },
    onInit() {

      this.carousel = new Swiper(`#${rootId} .swiper`, {
        speed: variables.carouselDefaultDuration,
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        spaceBetween: 20,
        slidesOffsetBefore:
          isElement(contentSection)
            ? offset(contentSection).left
            : variables.gridGap / 2,
        slidesOffsetAfter: variables.gridGap / 2,
        // navigation: {
        //   nextEl: `#${rootId} .js-home-usage-next`,
        //   prevEl: `#${rootId} .js-home-usage-prev`,
        //   disabledClass: variables.classNames.disabled
        // },
        pagination: {
          el: get(paginationSelector, `#${rootId}`),
          type: 'bullets',
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: maxCountWithoutDynamicBullets,
          renderBullet: function (index, className) {
            return `<span class='${className}'><span class='swiper-pagination-bullet-inner'>${index}</span></span>`;
          },
        },
      })
    },
    onDestroy() {
      if (this.carousel instanceof Swiper) {
        this.carousel.destroy();
        this.carousel = null;
      }
    }
  })
}